import { render, staticRenderFns } from "./CoUserCreateAdminModal.vue?vue&type=template&id=45e3491a&"
import script from "./CoUserCreateAdminModal.vue?vue&type=script&lang=ts&"
export * from "./CoUserCreateAdminModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports